import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { FoodEnergy_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Calories to Joules and Kilojoules Conversion Calculator | Cal to Joules & kJ';
const DESCRIPTION = 'Easily convert calories to joules, kilojoules, and more with our simple calculator. Whether you\'re converting kcal to J or cal to kJ, find accurate results quickly.';
const KEYWORDS = 'convert calories to joules, cal to joules, calories to kJ, kcal to joules, calorie to joule conversion, calories to joules conversion, convert calories to kilojoules, joules to calories, calorie to joule, calorie to kJ conversion, calorie joules, cal to joule conversion, kilojoules to calories';
const OG_URL = 'https://do-calculate.com/calculator/en/foodenergy/';
const apiEndpoint = `${SERVER_URL}/${FoodEnergy_EndPoint}`;
function FoodEnergyCalculator() {
    const [value, setValue] = useState(1);
    const [unitFrom, setUnitFrom] = useState('kcal');
    const [unitTo, setUnitTo] = useState('kcal');
    const [newValue, setNewValue] = useState(1);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleValueChange = (event) => {
        setValue(event.target.value);
    };
    const handleUnitFromChange = (event) => {
        setUnitFrom(event.target.value);
    };
    const handleUnitToChange = (event) => {
        setUnitTo(event.target.value);
    };
    const handleNewValueChange = (event) => {
        setNewValue(event.target.value);
    };
    const calculateFoodEnergy = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ value, unitFrom }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                if (unitTo === "kcal") {
                    setNewValue(data.result.kcal)
                } else if (unitTo === "cal") {
                    setNewValue(data.result.cal)
                } else if (unitTo === "J") {
                    setNewValue(data.result.J)
                } else if (unitTo === "kJ") {
                    setNewValue(data.result.kJ)
                }
            } else {
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
              <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '32px' }}>
                        <h1 style={{ fontSize: '16px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    Welcome to our energy conversion calculator! This tool allows you to seamlessly convert between calories, joules, and kilojoules. Whether you need to convert kcal to J, cal to kJ, or any other energy units, our calculator provides accurate results quickly. Ideal for nutritional analysis, scientific calculations, or simply converting energy values for personal use.
                                </p>
                                <p>
                                    With this calculator, you can:
                                    <ul>
                                        <li>Convert Calorie (kcal) to Joules (J) and Kilojoules (kJ).</li>
                                        <li>Switch between Calorie (cal) and Kilojoules (kJ) with ease.</li>
                                        <li>Get precise conversions for various applications including food energy and scientific research.</li>
                                    </ul>
                                </p>
                                <p>
                                    Simply enter your value and select the units for conversion. Our calculator will instantly provide the equivalent value in your desired unit. Enjoy a hassle-free and accurate conversion experience!
                                </p>
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col" className='calculatorStyle' style={{ minWidth: '200px' }}>
                                <div className='p-3 mb-2 bg-success text-white'>
                                    Food Energy Calculator
                                </div>
                                <hr />
                                <br />
                                <div className='form-group d-flex'>
                                    <div className="row">
                                        <div className="col">
                                            <div className='form-group d-flex'>
                                                <input
                                                    type="number"
                                                    id="from"
                                                    value={value}
                                                    onChange={handleValueChange}
                                                    className="form-control ml-2"
                                                    style={{ width: '70px', marginLeft: '10px' }}
                                                    placeholder="175"
                                                />
                                                <label htmlFor="unitFrom">Unit </label>
                                                <select id="unitFrom" style={{ width: '150px' }} className="form-select" value={unitFrom} onChange={handleUnitFromChange}>
                                                    <option value="kcal">Calorie (kcal)</option>
                                                    <option value="cal">Calorie (cal)</option>
                                                    <option value="kJ">Kilojoules (kJ)</option>
                                                    <option value="J">Joules (J)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className='form-group d-flex'>
                                                <b>
                                                    <label className="form-label ms-2" style={{ marginRight: '10px' }} >= </label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="to"
                                                    value={newValue}
                                                    onChange={handleNewValueChange}
                                                    className="form-control ml-2"
                                                    style={{ width: '70px', marginLeft: '10px' }}
                                                    placeholder="0"
                                                    readOnly
                                                />
                                                <label htmlFor="unitTo">Unit </label>
                                                <select id="unitTo" style={{ width: '150px' }} className="form-select" value={unitTo} onChange={handleUnitToChange}>
                                                    <option value="kcal">Calorie (kcal)</option>
                                                    <option value="cal">Calorie (cal)</option>
                                                    <option value="J">Joules (J)</option>
                                                    <option value="kJ">Kilojoules (kJ)</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateFoodEnergy} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> Error Occurred:</u></b> Please enter all fields correctly.</div>}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.healthCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Calories to Joules and Kilojoules Conversion: Methods, Tables, and Calculations:</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Article: Calories and How to Calculate Them for Proper Nutrition</h2></u> <br />
                                <p>
                                Calories are a standard unit of energy measurement in nutrition. Converting these calories to joules and kilojoules is often necessary for various applications. This article explains the conversion processes and provides a handy conversion table for ease of use.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>What Are Calories, Joules, and Kilojoules?</h2></u>
                                <ul>
                                    <li>
                                        Calories: Calories measure energy in nutrition. Abbreviated as "cal," they quantify the energy contained in food and beverages.
                                    </li>
                                    <li>
                                        Joules: Joules are a metric unit for energy used in science and engineering. 1 joule is approximately 0.239 calories.
                                    </li>
                                    <li>
                                        Kilojoules: Kilojoules are another energy unit, with 1 kilojoule equal to 239 calories.
                                    </li>
                                </ul>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Convert Calories to Joules:</h2></u> <br />
                                <p>
                                    To convert calories to joules, use this formula:
                                    1 calorie = 4.184 joules.
                                    Multiply the number of calories by 4.184 to find the equivalent in joules. For instance, 100 calories equal 418.4 joules.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Convert Calories to Kilojoules:</h2></u> <br />
                                <p>
                                    To convert calories to kilojoules, use this formula:
                                    1 calorie = 0.004184 kilojoules
                                    Divide the number of calories by 239 to get the kilojoules. For example, 100 calories are 0.4184 kilojoules.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Calories to Joules and Kilojoules Conversion Table:</h2></u> <br />
                                Use this table to quickly convert calories to joules and kilojoules:
                                <table >
                                    <thead>
                                        <tr>
                                            <th >Calories</th>
                                            <th >Joules</th>
                                            <th >Kilojoules</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>4.184</td>
                                            <td>0.004184</td>
                                        </tr>
                                        <tr>
                                            <td>10</td>
                                            <td>41.84</td>
                                            <td>0.04184</td>
                                        </tr>
                                        <tr>
                                            <td>50</td>
                                            <td>209.2</td>
                                            <td>0.2092</td>
                                        </tr>
                                        <tr>
                                            <td>100</td>
                                            <td>418.4</td>
                                            <td>0.4184</td>
                                        </tr>
                                        <tr>
                                            <td>500</td>
                                            <td>2092</td>
                                            <td>2.092</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How This Calculator Works:</h2></u> <br />
                                <p>
                                    This calculator facilitates the conversion of energy values between calories, joules, and kilojoules. Enter the value and original unit, and the calculator will provide the equivalent value in your selected unit.
                                </p>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default FoodEnergyCalculator;
